import { render, staticRenderFns } from "./custom-contact-fields-input.vue?vue&type=template&id=48e14942&scoped=true&"
import script from "./custom-contact-fields-input.vue?vue&type=script&lang=ts&"
export * from "./custom-contact-fields-input.vue?vue&type=script&lang=ts&"
import style0 from "./custom-contact-fields-input.vue?vue&type=style&index=0&id=48e14942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e14942",
  null
  
)

export default component.exports